module.exports = "/_next/static/images/songwhipFavicon.external-149e098d71233fafdbe960792aefc3c0.svg";